import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosBold } from '../../../style/theme';

export const StyledLoginMenuSignedInAsMobile = styled.div`
    font-size: 1.36rem;
    color: ${theme.palette.darkGray};
    display: flex;
    flex-direction: column;

    ${theme.mediaQueries.tabletMaxOriginal} {
        font-size: 1.1rem;
    }
`;

export const StyledLoginMenuSignedInAsContentMobile = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
`;

export const StyledLoginMenuSignedInAsBoldMobile = styled(StyledLoginMenuSignedInAsMobile)`
    font-weight: bold;
    margin-bottom: 0.5rem;
`;

export const StyledMyContentSection = styled.div`
    border-bottom: 1px solid ${theme.palette.lightGray};
`;

export const StyledMenuHeaderLinks = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.1rem;
    padding-left: 1rem;
    padding-bottom: 2rem;
    margin-top: 1rem;
`;

export const StyledMenuHeaderLink = styled.button<{ active?: boolean }>`
    display: flex;
    align-items: center;
    column-gap: 0.65rem;
    font-size: 1.55rem;
    letter-spacing: 0;
    line-height: 1.93rem;
    font-family: ${fontFamilyAtosBold};
    font-weight: 800;
    align-self: flex-start;
    color: ${(p) => (p.active ? theme.palette.red : theme.colors.text.heading)};
    text-decoration: ${(p) => (p.active ? 'underline' : 'none')};
    
    &:hover {
        color: ${theme.palette.pink};
        & > svg {
            fill: ${theme.palette.pink};
        }
    }
`;

export const StyledNavigation = styled.nav`
    border-top: 1px solid ${theme.palette.lightGray};
    padding-top: 2rem;
    border-bottom: 1px solid ${theme.palette.lightGray};
    margin-bottom: 4rem;
`;

